var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMondayMarketerSquare = function SvgMondayMarketerSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CA0C6B",
    d: "M30.518 33.545V51.31c0 .46.373.834.834.834h9.296c.46 0 .834-.373.834-.834V35.141a3.026 3.026 0 0 1 3.027-3.025 3.026 3.026 0 0 1 3.027 3.025V51.31c0 .46.373.834.834.834h9.296c.46 0 .834-.373.834-.834V33.545c0-7.343-6.264-13.295-13.991-13.295s-13.99 5.953-13.99 13.295"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_1371_406872)",
    d: "M13.5 33.545V51.31c0 .46.373.834.834.834h9.296c.46 0 .834-.373.834-.834V35.141a3.026 3.026 0 0 1 3.027-3.025 3.026 3.026 0 0 1 3.027 3.025V51.31c0 .46.373.834.834.834h9.296c.46 0 .834-.373.834-.834V33.545c0-7.343-6.264-13.295-13.991-13.295S13.5 26.203 13.5 33.545"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8C3DD",
    d: "M13.5 41.898h10.962v9.275a.97.97 0 0 1-.97.97h-9.02a.97.97 0 0 1-.972-.97zM30.52 41.898h10.962v9.275a.97.97 0 0 1-.971.97h-9.02a.97.97 0 0 1-.971-.97zM47.54 41.898H58.5v9.275a.97.97 0 0 1-.97.97h-9.02a.97.97 0 0 1-.972-.97z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1371_406872",
    x1: 12.588,
    x2: 58.099,
    y1: 49.885,
    y2: 44.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF158A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#FF158A",
    stopOpacity: 0.5
  })))));
};
export default SvgMondayMarketerSquare;